import { singleOrGrouped } from '../types';
import { GroupPropertyBatchViewAccordion } from './grouped';
import { SinglePropertyBatchViewAccordion } from './single';

export const PropertyBatchViewAccordion = singleOrGrouped(
  SinglePropertyBatchViewAccordion,
  GroupPropertyBatchViewAccordion
);
